<template>
  <div>
    <!-- 引入面包屑式内页 Banner 极具专业感 -->
    <PageBanner :title="product.name || '产品详情'" subtitle="中泉环保 · 专业非标定制绿色处理装备" />

    <section class="page-section">
      <div class="pro-detail">
        <b-row class="align-items-center">
          <b-col md="7">
            <div class="pro-detail__img-wrap">
              <img :src="product.img" :alt="product.name" class="pro-detail__img" />
              <div class="pro-detail__img-badge">自主源头制造</div>
            </div>
          </b-col>
          <b-col md="5" class="mt-4 mt-md-0">
            <div class="pro-detail__info">
              <span class="pro-detail__tag">工业净化处理设备</span>
              <h2>{{ product.name }}</h2>

              <div class="pro-detail__spec-list">
                <div class="spec-item">
                  <span class="label">材质类型</span>
                  <span class="val">高强度 PP 板材 / 优质 304 不锈钢</span>
                </div>
                <div class="spec-item">
                  <span class="label">适用工况</span>
                  <span class="val">酸碱废气、有机恶臭、精密除尘、厨房净化</span>
                </div>
                <div class="spec-item">
                  <span class="label">生产工艺</span>
                  <span class="val">激光下料、精密折弯、满焊防漏、高标准组装</span>
                </div>
              </div>

              <div class="pro-detail__contact-box">
                <span class="lbl">技术服务电话</span>
                <div v-for="(c, idx) in company.contacts" :key="idx" class="pro-detail__contact-item">
                  <a :href="'tel:' + c.phone" class="phone">{{ c.phone }}</a>
                  <span class="mgr">联系人：{{ c.name }}</span>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>

      <div class="pro-detail__desc" v-if="product.desc">
        <SectionTitle title="产品详情" subtitle="工艺精密 · 高清细节大图展示" tag="Product Details" />
        <div class="pro-detail__desc-img-wrap">
          <img :src="product.desc" alt="产品详情" class="pro-detail__desc-img" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import SectionTitle from '@/components/SectionTitle.vue'
import PageBanner from '@/components/PageBanner.vue'
import { COMPANY } from '@/constants/company'
import { getStaticProductById } from '@/constants/staticData'

export default {
  name: 'ProDetail',
  components: { SectionTitle, PageBanner },
  data () {
    return {
      company: COMPANY,
      product: {}
    }
  },
  created () {
    this.product = getStaticProductById(this.$route.params.id)
  }
}
</script>

<style lang="scss" scoped>
.pro-detail {
  padding: 0 1.5rem;

  &__img-wrap {
    position: relative;
    border-radius: var(--radius-md);
    overflow: hidden;
    box-shadow: var(--shadow-lg);
    border: 1px solid var(--color-border);
  }

  &__img {
    width: 100%;
    aspect-ratio: 4 / 3;
    object-fit: cover;
    display: block;
    transition: transform 0.4s ease;

    &:hover {
      transform: scale(1.02);
    }
  }

  &__img-badge {
    position: absolute;
    top: 1rem;
    left: 1rem;
    background: var(--color-primary);
    color: #fff;
    padding: 0.35rem 0.85rem;
    font-size: 0.8rem;
    font-weight: 700;
    border-radius: 4px;
    box-shadow: var(--shadow-sm);
  }

  &__info {
    display: flex;
    flex-direction: column;
    text-align: left;
    padding-left: 2.5rem;

    h2 {
      font-size: 2.25rem;
      font-weight: 800;
      color: var(--color-dark);
      margin-bottom: 1.5rem;
      line-height: 1.3;
    }
  }

  &__tag {
    font-size: 0.8rem;
    font-weight: 700;
    color: var(--color-primary);
    text-transform: uppercase;
    letter-spacing: 0.1em;
    margin-bottom: 0.5rem;
    display: block;
  }

  &__spec-list {
    display: flex;
    flex-direction: column;
    gap: 0.875rem;
    margin-bottom: 2rem;
    border-top: 1px solid var(--color-border);
    border-bottom: 1px solid var(--color-border);
    padding: 1.25rem 0;

    .spec-item {
      display: grid;
      grid-template-columns: 6rem 1fr;
      font-size: 0.95rem;

      .label {
        color: var(--color-text-light);
        font-weight: 600;
      }

      .val {
        color: var(--color-text);
        font-weight: 500;
      }
    }
  }

  &__contact-box {
    background: var(--color-primary-light);
    border-radius: var(--radius-sm);
    padding: 1.25rem;
    margin-bottom: 1.75rem;
    display: flex;
    flex-direction: column;
    text-align: left;
    border-left: 4px solid var(--color-primary);
    gap: 0.5rem;

    .lbl {
      font-size: 0.8rem;
      color: var(--color-primary-dark);
      font-weight: 700;
      margin-bottom: 0.25rem;
    }

    .phone {
      font-size: 1.6rem;
      font-weight: 800;
      color: var(--color-dark);
      text-decoration: none;
      line-height: 1.1;

      &:hover {
        color: var(--color-primary-dark);
      }
    }

    .mgr {
      font-size: 0.85rem;
      color: var(--color-text-muted);
      font-weight: 600;
    }
  }

  &__contact-item {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    &:not(:last-child) {
      border-bottom: 1px dashed var(--color-border);
      padding-bottom: 0.5rem;
    }
  }

  &__btn {
    width: 100%;
    padding: 0.85rem 1.5rem !important;
    font-size: 1.05rem !important;
    font-weight: 700 !important;
    border-radius: var(--radius-sm) !important;
    background: var(--color-accent) !important;
    border-color: var(--color-accent) !important;
    box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3) !important;
    transition: all 0.2s ease;

    &:hover {
      background: var(--color-accent-dark) !important;
      border-color: var(--color-accent-dark) !important;
      transform: translateY(-1px);
      box-shadow: 0 6px 20px rgba(217, 119, 6, 0.45) !important;
    }
  }

  &__desc {
    margin-top: 4.5rem;
    padding: 0 1.5rem;
  }

  &__desc-img-wrap {
    background: #fff;
    padding: 1rem;
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-md);
    border: 1px solid var(--color-border);
    margin-top: 1.5rem;
  }

  &__desc-img {
    width: 100%;
    border-radius: var(--radius-sm);
    display: block;
  }
}

@media (max-width: 992px) {
  .pro-detail {
    padding: 0;

    &__info {
      padding-left: 0;
      margin-top: 1.5rem;
    }
  }
}
</style>
